import React, { useCallback } from 'react'
import { AbstractBulkUpload } from '../../components/AbstractBulkFileUpload'
import { useLazyApiData, useStores } from '../../data/store'

const { REACT_APP_ENDPOINT = '' } = window?._env_

export const UploadBulkMidToPackage = () => {
  const { bulkAddPackageToMid } = useStores((store) => ({
    bulkAddPackageToMid: store.packageToMId.bulkAddPackageToMid,
  }))

  const [lazyBulkAddPackageToMid, bulkAddPackageToMidHandler] = useLazyApiData(bulkAddPackageToMid)

  const [selctedFileInfo, setSelectedFileInfo] = React.useState({
    fileName: undefined,
    data: [],
    keys: [],
  })

  const FILE_COLLUMNS = ['Merchant Id', 'Package Name']
  const respCollumns = ['mid', 'packageName', 'status', 'message']

  const processPackagesToMidFile = useCallback(() => {
    lazyBulkAddPackageToMid(selctedFileInfo.data)
  }, [lazyBulkAddPackageToMid, selctedFileInfo.data])

  return (
    <AbstractBulkUpload
      apiHandler={bulkAddPackageToMidHandler}
      selctedFileInfo={selctedFileInfo}
      innerCompTitle={'Please upload mid to package mapping file'}
      innnerCompSubtitle={'Browse your mid to package mapping file'}
      setSelectedFileInfo={setSelectedFileInfo}
      expectedFileCollumns={FILE_COLLUMNS}
      sampleFilePath={`${REACT_APP_ENDPOINT}/sample_bulk_mapping_package_to_mid_file.xlsx`}
      onConfirmButtonPress={processPackagesToMidFile}
      respCollumns={respCollumns}
    />
  )
}
